<template>
  <router-view/>
</template>

<script>
export default {
  mounted() {
    document.body.classList.add('background');
  },
  beforeDestroy() {
    document.body.classList.remove('background');
  },
};
</script>


<style>
  @import '../../../public/css/modules/auth.css';
</style>
